import React from "react";

import { CoachProfileModel } from "app/models/scheduling/CoachProfileModel";

import styles from "./CoachInfo.module.scss";
import { cls } from "app/utils";

type PropsDef = {
  coach: CoachProfileModel;
  singleCoach?: boolean;
};

const CoachInfo = ({ coach, singleCoach = false }: PropsDef) => {
  return (
    <div
      className={cls({
        [styles.parent_single_coach]: singleCoach,
        [styles.parent_multi_coach]: !singleCoach,
      })}
    >
      <div className={styles.container}>
        <div className={styles.info_text}>
          <div className={styles.coach_name}>{coach?.fullName}</div>
        </div>

        <img className={styles.avatar} src={coach?.profilePicture} />
      </div>
    </div>
  );
};

export default CoachInfo;
